/// <reference types="vite-plus/client" />

// Vite specific client environment
import { validateEnv, type ClientEnv } from "./client-base"

// Vite uses import.meta.env
const viteEnv = {
  CLOUDFLARE_ACCOUNT_HASH: import.meta.env.VITE_CLOUDFLARE_ACCOUNT_HASH,
  CLOUDFLARE_IMAGES_URL: import.meta.env.VITE_CLOUDFLARE_IMAGES_URL,
  CONVEX_URL: import.meta.env.VITE_CONVEX_URL,
  CONVEX_SITE_URL: import.meta.env.VITE_CONVEX_SITE_URL,
}

// Validate environment variables on startup (development only)
if (import.meta.env.DEV && typeof window !== "undefined") {
  const missingVars: string[] = []

  if (!viteEnv.CONVEX_URL) missingVars.push("VITE_CONVEX_URL")
  if (!viteEnv.CONVEX_SITE_URL) missingVars.push("VITE_CONVEX_SITE_URL")

  if (missingVars.length > 0) {
    console.error("❌ Missing required environment variables:")
    missingVars.forEach((v) => console.error(`  - ${v}`))
    console.error("\n💡 Please add these to your .env file")
  }
}

// Export validated env
export const env: ClientEnv = validateEnv(viteEnv, "Vite")
export const clientEnv = env // Alias for consistency

// Re-export types
export type { ClientEnv } from "./client-base"
